export default __webpack_public_path__ + "static/media/userManagement.b502158a.svg";